import Rating from "@material-ui/lab/Rating";
import ValidationMessages from "../../utils/ValidationMessages";
import { actualRatingYesNoValue, yesNoIcons } from "../../utils/utils";
import { useState } from "react";

const InputYesNo = ({ label, state, inputName, handleRatingChange, validator }) => {
    const [customIcons] = useState(yesNoIcons);

    const IconContainer = (props) => {
        let { value, ...other } = props;
        let newValue = actualRatingYesNoValue[value];
        const classes = `icons-label yes-no-question ${state == newValue ? "active" : ""
            }`;
        return (
            <span {...other} className={classes}>
                {customIcons[value].icon}
            </span>
        );
    };

    return (
        <div>
            <h5 className="required">
                {label}
            </h5>

            <div className="form-group row mt-md-5 mt-3 mb-4">
                <div className="col-sm-8 offset-sm-3 text-center">
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            <Rating
                                max={2}
                                className="large-rating-icons"
                                name={inputName}
                                defaultValue={0}
                                onChange={(event) => handleRatingChange(event, true)}
                                getLabelText={(value) => customIcons[value].label}
                                IconContainerComponent={(props) => {
                                    return IconContainer(props);
                                }}
                                size="large"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {validator.current.message(inputName, state, "required", ValidationMessages().yesNo)}
        </div>

    )

}

export default InputYesNo;